import React from "react";
import { PageHero } from "../components/Sections";
import { Card } from "../components/ui/card";
import { grievance } from "../mock/data";
import { useSettings } from "../context/SettingsContext";
import { Headset, Mail } from "lucide-react";

export default function Grievance() {
  const { settings } = useSettings();
  const officer = [
    { label: "Grievance Officer Name / Designation", value: settings.grievance_officer_name },
    { label: "Email", value: settings.grievance_officer_email },
    { label: "Phone", value: settings.grievance_officer_phone },
    { label: "Postal Address", value: settings.grievance_officer_address },
    { label: "Expected Response Time", value: settings.grievance_response_time },
  ];
  return (
    <div>
      <PageHero title="Grievance Redressal"
        subtitle={grievance.intro} crumbs={[{ label: "Grievance Redressal" }]} />
      <section className="section-pad">
        <div className="container-page grid gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <h2 className="font-heading text-xl font-semibold flex items-center gap-2">
              <Headset className="h-5 w-5 text-primary" /> Complaint Process
            </h2>
            <ol className="mt-5 space-y-4">
              {grievance.process.map((p, i) => (
                <li key={i} className="flex gap-4">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-primary-foreground">{i + 1}</span>
                  <p className="pt-1 text-muted-foreground">{p}</p>
                </li>
              ))}
            </ol>
            <div className="mt-8 rounded-xl border border-primary/20 bg-secondary/50 p-4 text-sm text-muted-foreground">
              For complaints relating to a specific lender/insurer, the matter may be escalated to that regulated
              entity's grievance channel, and further to the applicable regulatory grievance mechanism if unresolved.
            </div>
          </div>
          <aside>
            <Card className="border p-6">
              <h3 className="font-heading text-lg font-semibold flex items-center gap-2">
                <Mail className="h-5 w-5 text-primary" /> Grievance Officer
              </h3>
              <dl className="mt-4 space-y-3">
                {officer.map((o) => (
                  <div key={o.label}>
                    <dt className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{o.label}</dt>
                    <dd className="mt-0.5 text-sm font-medium">{o.value || <span className="text-muted-foreground italic">[To be provided]</span>}</dd>
                  </div>
                ))}
              </dl>
            </Card>
          </aside>
        </div>
      </section>
    </div>
  );
}
